import BillingsOrderForwardTaxiTaxiAddRequest, {
  BillingsOrderForwardTaxiTaxiAddRequestBillingNode,
  BillingsOrderForwardTaxiTaxiAddRequestBonusContribution,
  BillingsOrderForwardTaxiTaxiAddRequestBonusContributionFavorableDistance,
  BillingsOrderForwardTaxiTaxiAddRequestBonusContributionOther,
  BillingsOrderForwardTaxiTaxiAddRequestContribution,
  BillingsOrderForwardTaxiTaxiAddRequestContributionType,
  BillingsOrderForwardTaxiTaxiAddRequestPenaltyContribution,
  BillingsOrderForwardTaxiTaxiAddRequestPenaltyContributionBeingLate,
  BillingsOrderForwardTaxiTaxiAddRequestPenaltyContributionIncompatibleCar,
  BillingsOrderForwardTaxiTaxiAddRequestPenaltyContributionOther,
  BillingsOrderForwardTaxiTaxiAddRequestPenaltyContributionWrongRoute,
} from "../../../../../api/raily/billings/order-forward/taxi-taxi/add/billings-order-forward-taxi-taxi-add.request";
import BillingsOrderForwardTaxiTaxiAddParams, {
  BillingsOrderForwardTaxiTaxiAddParamsBillingNode,
  BillingsOrderForwardTaxiTaxiAddParamsBonusContribution,
  BillingsOrderForwardTaxiTaxiAddParamsBonusContributionFavorableDistance,
  BillingsOrderForwardTaxiTaxiAddParamsBonusContributionOther,
  BillingsOrderForwardTaxiTaxiAddParamsContribution,
  BillingsOrderForwardTaxiTaxiAddParamsContributionType,
  BillingsOrderForwardTaxiTaxiAddParamsPenaltyContribution,
  BillingsOrderForwardTaxiTaxiAddParamsPenaltyContributionBeingLate,
  BillingsOrderForwardTaxiTaxiAddParamsPenaltyContributionIncompatibleCar,
  BillingsOrderForwardTaxiTaxiAddParamsPenaltyContributionOther,
  BillingsOrderForwardTaxiTaxiAddParamsPenaltyContributionWrongRoute,
} from "./billings-order-forward-taxi-taxi-add-params";

const createBillingBonusContributionFavorableDistance = (
  contribution: BillingsOrderForwardTaxiTaxiAddParamsBonusContributionFavorableDistance,
): BillingsOrderForwardTaxiTaxiAddRequestBonusContributionFavorableDistance => {
  return {
    comment: contribution.comment,
    distance: contribution.distance,
    rate: contribution.rate,
    type: BillingsOrderForwardTaxiTaxiAddRequestContributionType.BONUS_FAVORABLE_DISTANCE,
  };
};

const createBillingBonusContributionOther = (
  contribution: BillingsOrderForwardTaxiTaxiAddParamsBonusContributionOther,
): BillingsOrderForwardTaxiTaxiAddRequestBonusContributionOther => {
  return {
    amount: contribution.amount,
    comment: contribution.comment,
    type: BillingsOrderForwardTaxiTaxiAddRequestContributionType.BONUS_OTHER,
  };
};

const createBillingBonusContribution = (
  contribution: BillingsOrderForwardTaxiTaxiAddParamsBonusContribution,
): BillingsOrderForwardTaxiTaxiAddRequestBonusContribution => {
  switch (contribution.type) {
    case BillingsOrderForwardTaxiTaxiAddParamsContributionType.BONUS_FAVORABLE_DISTANCE:
      return createBillingBonusContributionFavorableDistance(
        contribution as BillingsOrderForwardTaxiTaxiAddParamsBonusContributionFavorableDistance,
      );
    case BillingsOrderForwardTaxiTaxiAddParamsContributionType.BONUS_OTHER:
      return createBillingBonusContributionOther(
        contribution as BillingsOrderForwardTaxiTaxiAddParamsBonusContributionOther,
      );
  }
};

const createBillingPenaltyOther = (
  contribution: BillingsOrderForwardTaxiTaxiAddParamsPenaltyContributionOther,
): BillingsOrderForwardTaxiTaxiAddRequestPenaltyContributionOther => {
  return {
    amount: contribution.amount,
    comment: contribution.comment,
    type: BillingsOrderForwardTaxiTaxiAddRequestContributionType.PENALTY_OTHER,
  };
};

const createBillingPenaltyIncompatibleCar = (
  contribution: BillingsOrderForwardTaxiTaxiAddParamsPenaltyContributionIncompatibleCar,
): BillingsOrderForwardTaxiTaxiAddRequestPenaltyContributionIncompatibleCar => {
  return {
    amount: contribution.amount,
    comment: contribution.comment,
    type: BillingsOrderForwardTaxiTaxiAddRequestContributionType.PENALTY_INCOMPATIBLE_CAR,
  };
};

const createBillingPenaltyBeingLate = (
  contribution: BillingsOrderForwardTaxiTaxiAddParamsPenaltyContributionBeingLate,
): BillingsOrderForwardTaxiTaxiAddRequestPenaltyContributionBeingLate => {
  return {
    amount: contribution.amount,
    comment: contribution.comment,
    type: BillingsOrderForwardTaxiTaxiAddRequestContributionType.PENALTY_BEING_LATE,
  };
};

const createBillingPenaltyWrongRoute = (
  contribution: BillingsOrderForwardTaxiTaxiAddParamsPenaltyContributionWrongRoute,
): BillingsOrderForwardTaxiTaxiAddRequestPenaltyContributionWrongRoute => {
  return {
    amount: contribution.amount,
    comment: contribution.comment,
    type: BillingsOrderForwardTaxiTaxiAddRequestContributionType.PENALTY_WRONG_ROUTE,
  };
};

const createBillingPenaltyContribution = (
  contribution: BillingsOrderForwardTaxiTaxiAddParamsPenaltyContribution,
): BillingsOrderForwardTaxiTaxiAddRequestPenaltyContribution => {
  switch (contribution.type) {
    case BillingsOrderForwardTaxiTaxiAddParamsContributionType.PENALTY_BEING_LATE:
      return createBillingPenaltyBeingLate(
        contribution as BillingsOrderForwardTaxiTaxiAddParamsPenaltyContributionBeingLate,
      );
    case BillingsOrderForwardTaxiTaxiAddParamsContributionType.PENALTY_OTHER:
      return createBillingPenaltyOther(
        contribution as BillingsOrderForwardTaxiTaxiAddParamsPenaltyContributionOther,
      );
    case BillingsOrderForwardTaxiTaxiAddParamsContributionType.PENALTY_INCOMPATIBLE_CAR:
      return createBillingPenaltyIncompatibleCar(
        contribution as BillingsOrderForwardTaxiTaxiAddParamsPenaltyContributionIncompatibleCar,
      );
    case BillingsOrderForwardTaxiTaxiAddParamsContributionType.PENALTY_WRONG_ROUTE:
      return createBillingPenaltyWrongRoute(
        contribution as BillingsOrderForwardTaxiTaxiAddParamsPenaltyContributionWrongRoute,
      );
  }
};

const createBillingContribution = (
  contribution: BillingsOrderForwardTaxiTaxiAddParamsContribution,
): BillingsOrderForwardTaxiTaxiAddRequestContribution => {
  switch (contribution.type) {
    case BillingsOrderForwardTaxiTaxiAddParamsContributionType.BONUS_FAVORABLE_DISTANCE:
    case BillingsOrderForwardTaxiTaxiAddParamsContributionType.BONUS_OTHER:
      return createBillingBonusContribution(
        contribution as BillingsOrderForwardTaxiTaxiAddParamsBonusContribution,
      );
    case BillingsOrderForwardTaxiTaxiAddParamsContributionType.PENALTY_BEING_LATE:
    case BillingsOrderForwardTaxiTaxiAddParamsContributionType.PENALTY_OTHER:
    case BillingsOrderForwardTaxiTaxiAddParamsContributionType.PENALTY_INCOMPATIBLE_CAR:
    case BillingsOrderForwardTaxiTaxiAddParamsContributionType.PENALTY_WRONG_ROUTE:
      return createBillingPenaltyContribution(
        contribution as BillingsOrderForwardTaxiTaxiAddParamsPenaltyContribution,
      );
  }
};

const createBillingContributions = (
  contributions: BillingsOrderForwardTaxiTaxiAddParamsContribution[],
): BillingsOrderForwardTaxiTaxiAddRequestContribution[] => {
  return contributions.map(createBillingContribution);
};

const createBillingNode = (
  node: BillingsOrderForwardTaxiTaxiAddParamsBillingNode,
): BillingsOrderForwardTaxiTaxiAddRequestBillingNode => {
  return {
    allowCharge: node.allowCharge,
    checkoutDate: node.checkoutDate,
    checkoutEventId: node.checkoutEventId,
    description: node.description,
    distance: node.distance,
    editableCoordinates: node.editableCoordinates,
    haltingTime: node.haltingTime,
    highwayCharge: node.highwayCharge,
    id: node.id,
    lat: node.lat,
    lon: node.lon,
    nodeId: node.nodeId,
    orderId: node.orderId,
    plannedDate: node.plannedDate,
    plannedDistance: node.plannedDistance,
  };
};

const createBillingNodes = (
  nodes: BillingsOrderForwardTaxiTaxiAddParamsBillingNode[],
): BillingsOrderForwardTaxiTaxiAddRequestBillingNode[] => {
  return nodes.map(createBillingNode);
};

const create = (
  params: BillingsOrderForwardTaxiTaxiAddParams,
): BillingsOrderForwardTaxiTaxiAddRequest => {
  return {
    billingContributions: createBillingContributions(
      params.billingContributions,
    ),
    billingNodes: createBillingNodes(params.billingNodes),
    forwardingId: params.forwardingId,
  };
};

const billingsOrderForwardTaxiTaxiAddParamsFactory = {
  create,
};

export default billingsOrderForwardTaxiTaxiAddParamsFactory;
